var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot-wrap f-row"},[_c('div',{staticClass:"con f-row jc-sb"},[_c('p',{staticClass:"left"},[_vm._v("欢迎您来到来到来来客后台系统！")]),_c('p',{staticClass:"right cur-po",on:{"click":_vm.logout}},[_vm._v("安全退出")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }